// import React, { useState, useEffect } from 'react';
// import { redeemPoints } from '../firebase';

// const RedeemPointsModal = ({ customer, rewardTiers, onClose, onSuccess }) => {
//   const [selectedReward, setSelectedReward] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [confirmStep, setConfirmStep] = useState(false);
//   const [animation, setAnimation] = useState('');
  
//   // Filter only rewards the customer is eligible for
//   const eligibleRewards = rewardTiers.filter(
//     tier => tier.active && tier.pointsRequired <= customer.totalPoints
//   ).sort((a, b) => a.pointsRequired - b.pointsRequired);
  
//   useEffect(() => {
//     // Auto-select the first eligible reward
//     if (eligibleRewards.length > 0 && !selectedReward) {
//       setSelectedReward(eligibleRewards[0]);
//     }
    
//     // Add entry animation
//     setAnimation('modal-enter');
    
//     // Add escape key handler
//     const handleEscape = (e) => {
//       if (e.key === 'Escape') {
//         handleClose();
//       }
//     };
    
//     document.addEventListener('keydown', handleEscape);
//     return () => {
//       document.removeEventListener('keydown', handleEscape);
//     };
//   }, [eligibleRewards, selectedReward]);
  
//   const handleRewardSelection = (reward) => {
//     setSelectedReward(reward);
//     setConfirmStep(false);
//   };
  
//   const handleProceedToConfirm = () => {
//     if (!selectedReward) {
//       setError('Please select a reward');
//       return;
//     }
//     setConfirmStep(true);
//   };
  
//   const handleClose = () => {
//     // Add exit animation
//     setAnimation('modal-exit');
//     setTimeout(() => {
//       onClose();
//     }, 300); // Match this to the CSS animation duration
//   };
  
//   const handleRedemption = async () => {
//     if (!selectedReward) {
//       setError('Please select a reward');
//       return;
//     }
    
//     try {
//       setLoading(true);
//       setError('');
      
//       const result = await redeemPoints(
//         customer.id, 
//         selectedReward.pointsRequired, 
//         selectedReward.name
//       );
      
//       if (result.success) {
//         // Show success animation before closing
//         setAnimation('redemption-success');
//         setTimeout(() => {
//           onSuccess(result.customer);
//         }, 1500);
//       } else {
//         setError('Failed to redeem points. Please try again.');
//         setConfirmStep(false);
//       }
//     } catch (err) {
//       setError('Error redeeming points: ' + err.message);
//       setConfirmStep(false);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // Reward tier selection screen
//   const renderSelectionStep = () => (
//     <>
//       <div className="customer-points-info">
//         <div className="points-icon">⭐</div>
//         <div className="points-details">
//           <div className="customer-name-display">{customer.name}</div>
//           <div className="points-balance">
//             <span className="points-value">{customer.totalPoints}</span>
//             <span className="points-label">available points</span>
//           </div>
//         </div>
//       </div>
      
//       {error && (
//         <div className="error-message redemption-error">
//           <span>{error}</span>
//           <button onClick={() => setError('')} className="close-btn">×</button>
//         </div>
//       )}
      
//       {eligibleRewards.length > 0 ? (
//         <>
//           <div className="rewards-selection">
//             <h4 className="rewards-selection-title">Select a Reward</h4>
//             <div className="rewards-grid">
//               {eligibleRewards.map(reward => (
//                 <div 
//                   key={reward.id}
//                   className={`reward-option ${selectedReward?.id === reward.id ? 'selected' : ''}`}
//                   onClick={() => handleRewardSelection(reward)}
//                 >
//                   <div className="reward-header">
//                     <div className="reward-option-name">{reward.name}</div>
//                     <div className="reward-option-points">{reward.pointsRequired} points</div>
//                   </div>
//                   <div className="reward-option-desc">{reward.description || "No description available"}</div>
//                   {selectedReward?.id === reward.id && (
//                     <div className="selected-indicator">✓</div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
          
//           <div className="redemption-footer">
//             <div className="redemption-note">
//               Redeeming points will deduct them from your balance in exchange for the selected reward.
//             </div>
//             <div className="redemption-actions">
//               <button 
//                 onClick={handleProceedToConfirm} 
//                 className="primary-button"
//                 disabled={!selectedReward}
//               >
//                 Continue
//               </button>
//               <button onClick={handleClose} className="secondary-button">Cancel</button>
//             </div>
//           </div>
//         </>
//       ) : (
//         <div className="no-rewards-message">
//           <div className="no-rewards-icon">😢</div>
//           <h4>No Eligible Rewards</h4>
//           <p>There are no rewards available for your current point balance.</p>
//           <button onClick={handleClose} className="secondary-button">Close</button>
//         </div>
//       )}
//     </>
//   );
  
//   // Confirmation screen
//   const renderConfirmStep = () => (
//     <>
//       <div className="confirmation-header">
//         <h4>Confirm Redemption</h4>
//       </div>
      
//       {error && (
//         <div className="error-message redemption-error">
//           <span>{error}</span>
//           <button onClick={() => setError('')} className="close-btn">×</button>
//         </div>
//       )}
      
//       <div className="confirmation-reward-card">
//         <div className="reward-card-header">
//           <div className="reward-name">{selectedReward.name}</div>
//           <div className="reward-points">{selectedReward.pointsRequired} points</div>
//         </div>
//         <div className="reward-description">
//           {selectedReward.description || "No description available"}
//         </div>
//       </div>
      
//       <div className="confirmation-details">
//         <div className="confirmation-row">
//           <span className="confirmation-label">Customer</span>
//           <span className="confirmation-value">{customer.name}</span>
//         </div>
//         <div className="confirmation-row">
//           <span className="confirmation-label">Current Points</span>
//           <span className="confirmation-value">{customer.totalPoints}</span>
//         </div>
//         <div className="confirmation-row highlight">
//           <span className="confirmation-label">Points to Redeem</span>
//           <span className="confirmation-value">-{selectedReward.pointsRequired}</span>
//         </div>
//         <div className="confirmation-row total">
//           <span className="confirmation-label">Remaining Balance</span>
//           <span className="confirmation-value">{customer.totalPoints - selectedReward.pointsRequired}</span>
//         </div>
//       </div>
      
//       <div className="confirmation-message">
//         Are you sure you want to redeem <strong>{selectedReward.pointsRequired} points</strong> for this reward?
//       </div>
      
//       <div className="redemption-actions">
//         <button 
//           onClick={handleRedemption} 
//           className="accent-button"
//           disabled={loading}
//         >
//           {loading ? (
//             <>
//               <span className="button-spinner"></span>
//               Processing...
//             </>
//           ) : (
//             "Confirm Redemption"
//           )}
//         </button>
//         <button 
//           onClick={() => setConfirmStep(false)} 
//           className="secondary-button"
//           disabled={loading}
//         >
//           Back
//         </button>
//         <button 
//           onClick={handleClose} 
//           className="secondary-button"
//           disabled={loading}
//         >
//           Cancel
//         </button>
//       </div>
//     </>
//   );
  
//   // Success animation screen (shown briefly)
//   const renderSuccessScreen = () => (
//     <div className="redemption-success-screen">
//       <div className="success-icon">✓</div>
//       <h3 className="success-title">Points Redeemed!</h3>
//       <p className="success-message">
//         You've successfully redeemed {selectedReward.pointsRequired} points 
//         for {selectedReward.name}.
//       </p>
//       <div className="confetti"></div>
//     </div>
//   );
  
//   return (
//     <div className="modal-backdrop" onClick={handleClose}>
//       <div 
//         className={`modal-content redemption-modal ${animation}`} 
//         onClick={e => e.stopPropagation()}
//       >
//         {!loading && animation !== 'redemption-success' && (
//           <div className="modal-header">
//             <h3 className="modal-title">Redeem Points</h3>
//             <button onClick={handleClose} className="close-button">×</button>
//           </div>
//         )}
        
//         <div className="modal-body">
//           {animation === 'redemption-success' ? (
//             renderSuccessScreen()
//           ) : confirmStep ? (
//             renderConfirmStep()
//           ) : (
//             renderSelectionStep()
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RedeemPointsModal;

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { redeemPoints } from '../firebase';

const RedeemPointsModal = ({ customer, rewardTiers, onClose, onSuccess, minRedemptionPoints, isRTL }) => {
  const { t } = useTranslation();
  const [pointsToRedeem, setPointsToRedeem] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [confirmStep, setConfirmStep] = useState(false);
  const [animation, setAnimation] = useState('');

  useEffect(() => {
    // Add entry animation
    setAnimation('modal-enter');

    // Add escape key handler
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const handlePointsChange = (e) => {
    const value = e.target.value;
    // Only allow positive integers
    if (value === '' || /^\d+$/.test(value)) {
      setPointsToRedeem(value);
      setError('');
    }
  };

  const handleProceedToConfirm = () => {
    const points = parseInt(pointsToRedeem, 10);
    if (!points || points <= 0) {
      setError(t('redemption.enterValidPoints'));
      return;
    }
    if (points > customer.totalPoints) {
      setError(t('redemption.insufficientPoints'));
      return;
    }
    if (minRedemptionPoints && points < minRedemptionPoints) {
      setError(t('redemption.minimumPoints', { minimum: minRedemptionPoints }));
      return;
    }
    setConfirmStep(true);
  };
  
  const handleClose = () => {
    // Add exit animation
    setAnimation('modal-exit');
    setTimeout(() => {
      onClose();
    }, 300); // Match this to the CSS animation duration
  };
  
  const handleRedemption = async () => {
    const points = parseInt(pointsToRedeem, 10);
    if (!points || points <= 0) {
      setError(t('redemption.enterValidPoints'));
      return;
    }

    try {
      setLoading(true);
      setError('');

      const result = await redeemPoints(
        customer.id,
        points,
        t('redemption.manualRedemption')
      );

      if (result.success) {
        // Show success animation before closing
        setAnimation('redemption-success');
        setTimeout(() => {
          onSuccess(result.customer);
        }, 1500);
      } else {
        setError(t('redemption.error.general'));
        setConfirmStep(false);
      }
    } catch (err) {
      setError(t('redemption.error.specific', { message: err.message }));
      setConfirmStep(false);
    } finally {
      setLoading(false);
    }
  };
  
  const parsedPoints = parseInt(pointsToRedeem, 10) || 0;
  const remainingBalance = customer.totalPoints - parsedPoints;

  // Points input screen
  const renderSelectionStep = () => (
    <>
      <div className="customer-points-info">
        <div className="points-icon">⭐</div>
        <div className="points-details">
          <div className="customer-name-display">{customer.name}</div>
          <div className="points-balance">
            <span className="points-value">{customer.totalPoints}</span>
            <span className="points-label">{t('redemption.availablePoints')}</span>
          </div>
        </div>
      </div>

      {error && (
        <div className="error-message redemption-error">
          <span>{error}</span>
          <button onClick={() => setError('')} className="close-btn">×</button>
        </div>
      )}

      <div className="rewards-selection">
        <h4 className="rewards-selection-title">{t('redemption.enterPoints')}</h4>
        <div className="points-input-container">
          <input
            type="text"
            inputMode="numeric"
            className="points-input"
            value={pointsToRedeem}
            onChange={handlePointsChange}
            placeholder={t('redemption.pointsPlaceholder')}
            autoFocus
          />
          {parsedPoints > 0 && parsedPoints <= customer.totalPoints && (
            <div className="points-preview">
              <span className="preview-label">{t('redemption.confirm.remainingBalance')}:</span>
              <span className="preview-value">{remainingBalance} {t('redemption.points')}</span>
            </div>
          )}
        </div>
      </div>

      <div className="redemption-footer">
        <div className="redemption-note">
          {t('redemption.note')}
        </div>
        <div className="redemption-actions">
          <button
            onClick={handleProceedToConfirm}
            className="primary-button"
            disabled={!parsedPoints || parsedPoints <= 0 || parsedPoints > customer.totalPoints}
          >
            {t('redemption.continue')}
          </button>
          <button onClick={handleClose} className="secondary-button">{t('redemption.cancel')}</button>
        </div>
      </div>
    </>
  );
  
  // Confirmation screen
  const renderConfirmStep = () => (
    <>
      <div className="confirmation-header">
        <h4>{t('redemption.confirm.title')}</h4>
      </div>

      {error && (
        <div className="error-message redemption-error">
          <span>{error}</span>
          <button onClick={() => setError('')} className="close-btn">×</button>
        </div>
      )}

      <div className="confirmation-details">
        <div className="confirmation-row">
          <span className="confirmation-label">{t('redemption.confirm.customer')}</span>
          <span className="confirmation-value">{customer.name}</span>
        </div>
        <div className="confirmation-row">
          <span className="confirmation-label">{t('redemption.confirm.currentPoints')}</span>
          <span className="confirmation-value">{customer.totalPoints}</span>
        </div>
        <div className="confirmation-row highlight">
          <span className="confirmation-label">{t('redemption.confirm.pointsToRedeem')}</span>
          <span className="confirmation-value">-{parsedPoints}</span>
        </div>
        <div className="confirmation-row total">
          <span className="confirmation-label">{t('redemption.confirm.remainingBalance')}</span>
          <span className="confirmation-value">{remainingBalance}</span>
        </div>
      </div>

      <div className="confirmation-message">
        {t('redemption.confirm.message', { points: parsedPoints })}
      </div>

      <div className="redemption-actions">
        <button
          onClick={handleRedemption}
          className="accent-button"
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="button-spinner"></span>
              {t('redemption.confirm.processing')}
            </>
          ) : (
            t('redemption.confirm.button')
          )}
        </button>
        <button
          onClick={() => setConfirmStep(false)}
          className="secondary-button"
          disabled={loading}
        >
          {t('redemption.confirm.back')}
        </button>
        <button
          onClick={handleClose}
          className="secondary-button"
          disabled={loading}
        >
          {t('redemption.cancel')}
        </button>
      </div>
    </>
  );
  
  // Success animation screen (shown briefly)
  const renderSuccessScreen = () => (
    <div className="redemption-success-screen">
      <div className="success-icon">✓</div>
      <h3 className="success-title">{t('redemption.success.title')}</h3>
      <p className="success-message">
        {t('redemption.success.pointsMessage', {
          points: parsedPoints
        })}
      </p>
      <div className="confetti"></div>
    </div>
  );
  
  return (
    <div className="modal-backdrop" onClick={handleClose}>
      <div 
        className={`modal-content redemption-modal ${animation} ${isRTL ? 'rtl' : ''}`} 
        onClick={e => e.stopPropagation()}
      >
        {!loading && animation !== 'redemption-success' && (
          <div className="modal-header">
            <h3 className="modal-title">{t('redemption.title')}</h3>
            <button onClick={handleClose} className="close-button">×</button>
          </div>
        )}
        
        <div className="modal-body">
          {animation === 'redemption-success' ? (
            renderSuccessScreen()
          ) : confirmStep ? (
            renderConfirmStep()
          ) : (
            renderSelectionStep()
          )}
        </div>
      </div>
    </div>
  );
};

export default RedeemPointsModal;